module.exports = __webpack_public_path__ + "static/assets/77fc53d5ba5e53eb24169059c17514fa.svg";